"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AbsenceModal;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const vacationViewUtils_1 = require("./vacationViewUtils");
/**
  * Godziny startują PUSTE - decyzja ownera 2026-09-02. Podpowiedziana z góry połówka dnia
  * wygląda jak wpis, którego nikt nie zrobił, i kusi, żeby ją zostawić bez czytania.
  */
const NO_TIME = "";
/** Nieobecność godzinowa idzie na pełne godziny, bez minut (decyzja ownera 2026-09-02). */
function isWholeHour(time) {
    return /^\d{2}:00$/.test(time);
}
/**
 * Z której puli schodzi typ nieobecności. Kolejność musi odpowiadać kontrolerowi
 * (assertTypeWithinPool): opieka → za święta → limit urlopu.
 */
function poolHint(type) {
    if (type.countsAsCare)
        return " (z puli opieki)";
    if (type.countsAsHoliday)
        return " (z puli za święta)";
    if (type.countsAgainstLimit)
        return "";
    return " (nie liczy do limitu)";
}
/** Odmiana słowa "dzień" przy liczbie: 1 dzień, 2 dni, 0,5 dnia. */
function daysWord(days) {
    if (!Number.isInteger(days))
        return "dnia";
    return days === 1 ? "dzień" : "dni";
}
/** Nazwa puli w zdaniu ("W puli opieki zostanie...") i jej stan po stronie osoby. */
function poolState(type, row) {
    if (!type || !row)
        return null;
    if (type.countsAsCare)
        return { label: "puli opieki", remaining: row.careRemainingDays };
    if (type.countsAsHoliday)
        return { label: "puli wolnego za święta", remaining: row.holidayRemainingDays };
    if (type.countsAgainstLimit)
        return { label: "limicie urlopu", remaining: row.remainingDays };
    return null;
}
/** Modal dodawania/edycji urlopu. Osobę wybieramy tylko przy dodawaniu. */
function AbsenceModal({ show, draft, persons, types, rows, onSave, onDelete, onClose, }) {
    const isEdit = !!draft?.id;
    const [personId, setPersonId] = (0, react_1.useState)();
    const [typeId, setTypeId] = (0, react_1.useState)();
    const [mode, setMode] = (0, react_1.useState)("whole");
    const [dateFrom, setDateFrom] = (0, react_1.useState)("");
    const [dateTo, setDateTo] = (0, react_1.useState)("");
    const [startTime, setStartTime] = (0, react_1.useState)(NO_TIME);
    const [endTime, setEndTime] = (0, react_1.useState)(NO_TIME);
    const [note, setNote] = (0, react_1.useState)("");
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!draft)
            return;
        setPersonId(draft.personId);
        setTypeId(draft.typeId ?? types[0]?.id);
        setDateFrom(draft.dateFrom ?? "");
        setDateTo(draft.dateTo ?? draft.dateFrom ?? "");
        // Otwarcie istniejącej nieobecności godzinowej wchodzi od razu w tryb części dnia.
        const hasTimes = !!draft.startTime && !!draft.endTime;
        setMode(hasTimes ? "partial" : "whole");
        setStartTime(draft.startTime ?? NO_TIME);
        setEndTime(draft.endTime ?? NO_TIME);
        setNote(draft.note ?? "");
        setError(null);
    }, [draft, types]);
    const selectedType = types.find((t) => t.id === typeId);
    const allowsPartial = selectedType?.allowsPartialDay !== false;
    // Typ bez zgody na godziny wyklucza tryb części dnia - także wtedy, gdy użytkownik
    // przestawił typ już po wybraniu trybu. Serwer odrzuciłby taki zapis komunikatem,
    // ale okno nie powinno pozwolić go nawet złożyć.
    (0, react_1.useEffect)(() => {
        if (!allowsPartial && mode === "partial")
            setMode("whole");
    }, [allowsPartial, mode]);
    const isPartial = mode === "partial";
    const minutes = isPartial ? (0, vacationViewUtils_1.partialDayMinutes)(startTime, endTime) : 0;
    const days = (0, vacationViewUtils_1.minutesToDays)(minutes);
    const row = rows.find((r) => r.personId === personId);
    const pool = poolState(selectedType, row);
    // Przy edycji własny wpis siedzi już w saldzie, więc trzeba go najpierw oddać puli,
    // inaczej podpowiedź odjęłaby te same dni dwa razy.
    const ownAbsence = draft?.id
        ? row?.absences.find((a) => a.id === draft.id)
        : undefined;
    const ownDays = ownAbsence && ownAbsence.typeId === typeId
        ? ownAbsence.workingDaysCount
        : 0;
    /** Sprawdzenia dublujące serwer - tylko po to, żeby odpowiedź przyszła od razu. */
    function validate() {
        if (!personId)
            return "Wybierz osobę";
        if (!typeId)
            return "Wybierz typ urlopu";
        if (!dateFrom)
            return "Podaj datę";
        if (isPartial) {
            if (!startTime || !endTime)
                return "Podaj godzinę od i do.";
            if (!isWholeHour(startTime) || !isWholeHour(endTime))
                return "Nieobecność godzinową wpisuje się w pełnych godzinach — bez minut.";
            if ((0, vacationViewUtils_1.isWeekendYmd)(dateFrom))
                return "To dzień wolny — nieobecności godzinowej nie ma z czego odjąć.";
            if (minutes <= 0)
                return "Godzina końcowa musi być późniejsza niż początkowa.";
            if (minutes >= vacationViewUtils_1.MINUTES_PER_DAY)
                return "To cały dzień pracy — przełącz na tryb «Całe dni».";
            return null;
        }
        if (!dateTo)
            return "Podaj zakres dat";
        if (dateTo < dateFrom)
            return "Data końcowa nie może być wcześniejsza niż początkowa";
        if (dateFrom.slice(0, 4) !== dateTo.slice(0, 4))
            return "Nieobecność na przełomie roku wpisz osobno dla każdego roku — pule dni rozliczają się rocznikami.";
        return null;
    }
    async function handleSave() {
        const problem = validate();
        if (problem)
            return setError(problem);
        setError(null);
        try {
            // Błąd serwera (np. brak dni opieki) pokazujemy TU, w modalu — modal zostaje otwarty,
            // tabela urlopów nie znika. Zamknięcie następuje po stronie rodzica dopiero po sukcesie.
            await onSave({
                id: draft?.id,
                personId: personId,
                typeId: typeId,
                dateFrom,
                // Część dnia z definicji mieści się w jednym dniu.
                dateTo: isPartial ? dateFrom : dateTo,
                startTime: isPartial ? startTime : null,
                endTime: isPartial ? endTime : null,
                note: note.trim() || null,
            });
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
    }
    /** Podpowiedź pod polami: ile dnia to zdejmuje i ile zostanie w puli. */
    function renderPartialHint() {
        if (!isPartial)
            return null;
        if (minutes <= 0 || minutes >= vacationViewUtils_1.MINUTES_PER_DAY)
            return null;
        // Przy edycji własny wpis wraca do puli, zanim odejmiemy nową długość.
        const available = pool ? pool.remaining + ownDays : null;
        const after = available !== null ? available - days : null;
        const overdrawn = after !== null && after < 0;
        return (react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: !overdrawn, className: `d-block mb-2${overdrawn ? " text-danger" : ""}` },
            (0, vacationViewUtils_1.formatHours)(minutes),
            " = ",
            (0, vacationViewUtils_1.formatDays)(days),
            " dnia.",
            " ",
            available === null ? ("Ten typ nie schodzi z żadnej puli.") : overdrawn ? (react_1.default.createElement(react_1.default.Fragment, null,
                "To wi\u0119cej, ni\u017C zosta\u0142o w ",
                pool.label,
                ":",
                " ",
                react_1.default.createElement("strong", null, (0, vacationViewUtils_1.formatDays)(available)),
                " ",
                daysWord(available),
                ". Serwer takiego wpisu nie przyjmie.")) : (react_1.default.createElement(react_1.default.Fragment, null,
                "W ",
                pool.label,
                " zostanie",
                " ",
                react_1.default.createElement("strong", null, (0, vacationViewUtils_1.formatDays)(after)),
                " ",
                daysWord(after),
                "."))));
    }
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show, onHide: onClose, centered: true },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, isEdit ? "Edytuj urlop" : "Dodaj urlop")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Osoba"),
                react_1.default.createElement(react_bootstrap_1.Form.Select, { value: personId ?? "", disabled: isEdit, onChange: (e) => setPersonId(Number(e.target.value) || undefined) },
                    react_1.default.createElement("option", { value: "" }, "\u2014 wybierz \u2014"),
                    persons.map((p) => (react_1.default.createElement("option", { key: p.personId, value: p.personId }, p.personName))))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Typ"),
                react_1.default.createElement(react_bootstrap_1.Form.Select, { value: typeId ?? "", onChange: (e) => setTypeId(Number(e.target.value) || undefined) }, types.map((t) => (react_1.default.createElement("option", { key: t.id, value: t.id },
                    t.name,
                    poolHint(t)))))),
            allowsPartial && (react_1.default.createElement(react_bootstrap_1.ButtonGroup, { className: "w-100 mb-2", "aria-label": "Wymiar nieobecno\u015Bci" },
                react_1.default.createElement(react_bootstrap_1.ToggleButton, { id: "absence-mode-whole", type: "radio", variant: "outline-primary", name: "absence-mode", value: "whole", checked: !isPartial, onChange: () => setMode("whole") }, "Ca\u0142e dni"),
                react_1.default.createElement(react_bootstrap_1.ToggleButton, { id: "absence-mode-partial", type: "radio", variant: "outline-primary", name: "absence-mode", value: "partial", checked: isPartial, onChange: () => setMode("partial") }, "Cz\u0119\u015B\u0107 dnia"))),
            isPartial ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "d-flex gap-2 mb-1 flex-wrap" },
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "flex-fill", style: { minWidth: 140 } },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Dzie\u0144"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", value: dateFrom, onChange: (e) => {
                                setDateFrom(e.target.value);
                                setDateTo(e.target.value);
                            } })),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "flex-fill", style: { minWidth: 110 } },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Od"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "time", 
                            // krok godzinowy: przeglądarka podpowiada same pełne godziny
                            step: 3600, value: startTime, onChange: (e) => setStartTime(e.target.value) })),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "flex-fill", style: { minWidth: 110 } },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Do"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "time", step: 3600, value: endTime, min: startTime || undefined, onChange: (e) => setEndTime(e.target.value) }))),
                renderPartialHint())) : (react_1.default.createElement("div", { className: "d-flex gap-2 mb-2 flex-wrap" },
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "flex-fill", style: { minWidth: 140 } },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Od"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", value: dateFrom, onChange: (e) => {
                            setDateFrom(e.target.value);
                            if (!dateTo || dateTo < e.target.value)
                                setDateTo(e.target.value);
                        } })),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "flex-fill", style: { minWidth: 140 } },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Do"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", value: dateTo, min: dateFrom || undefined, onChange: (e) => setDateTo(e.target.value) })))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Notatka"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 2, maxLength: 500, value: note, onChange: (e) => setNote(e.target.value) })),
            error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", dismissible: true, onClose: () => setError(null), className: "mt-3 mb-0" }, error))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, { className: "justify-content-between" },
            react_1.default.createElement("div", null, isEdit && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-danger", onClick: () => draft?.id && onDelete(draft.id) }, "Usu\u0144"))),
            react_1.default.createElement("div", { className: "d-flex gap-2" },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: onClose }, "Anuluj"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleSave }, "Zapisz")))));
}
